import React from 'react'
import DetailHeader from '@/component/detail-header'
import 'swiper/css'
import '@/scss/detail.scss'
import Topic from './topic'

export default class HomeComponent extends React.Component {

  render() {
    return (
      <div id='app-main' className='detail'> 
          <DetailHeader />
          <div className='app-content'>
             <Topic />
          </div>
      </div>
    )
  }
 
  componentDidMount(): void {
    
  }

}